import { useEffect, useState, useCallback } from "react";
import { getJsonURL } from "../../utils/ConstantsURL";

export const useFetchJson = () => {
  const [jsonData, setJsonData] = useState({});
  const [loadingJson, setLoadingJson] = useState(false);

  const fetchJson = useCallback(async () => {
    setLoadingJson(true);

    try {
      let response = await fetch(getJsonURL(), {
        method: "GET",
      });

      let data = await response.json();

      if (response.ok) {
        setJsonData(data.data || {});
        setLoadingJson(false);
      } else {
        throw new Error(data.message);
      }
    } catch (error) {
      console.error("Error al obtener JSON:", error);
      setLoadingJson(false);
    }
  }, []);

  useEffect(() => {
    fetchJson();
  }, [fetchJson]);

  return {
    jsonData,
    loadingJson,
    refetchJson: fetchJson,
  };
};
